import React, { useMemo } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import FileItem from "../../../../../FileItem";
import { SourceItem } from "../../../../../../pages/ResourcePool/service";
import { Tooltip } from "antd";
import SourceInfo from "../../../../../CourseComponents/Resource/ListItem/Components/SourceInfo";

interface AsideLinkProps {
    item: SourceItem;
    desc?: string;
    active?: boolean;
    onClick: () => void;
    finished?: boolean;
}

export default function AsideLink({ item, active, onClick }: AsideLinkProps) {
    const filename = item.sourceFileEntity.fileName;
    const ext = useMemo(() => {
        const ext = item.sourceFileEntity.fileType;
        return ext ? `.${ext}` : "";
    }, [filename]);

    const title = useMemo(() => {
        const append = filename.length > 10 ? "..." : "";
        return filename.substring(0, 10).replaceAll(ext, "") + append;
    }, [ext, filename]);

    return (
        <div
            className={classNames(styles.root, { [styles.active]: active })}
            onClick={onClick}>
            <div className={styles.main}>
                <FileItem
                    style={{ width: "100%" }}
                    text={
                        <Tooltip title={item.sourceFileEntity.fileName}>
                            <span className={styles.title}>
                                {title}
                                {ext}
                            </span>
                        </Tooltip>
                    }
                    fileType={item.sourceFileEntity.fileType}
                />
            </div>

            <div className={styles.desc}>
                <SourceInfo source={item} className={styles.infos}>
                    {item.sourceFileEntity.description && (
                        <span>{item.sourceFileEntity.description}</span>
                    )}
                </SourceInfo>
            </div>
        </div>
    );
}
